import { useContext } from 'react';
import { AppConfigContext } from '../contexts/ConfigContext';
export const useAppConfig = () => {
    const context = useContext(AppConfigContext);
    if (!context) {
        throw new Error('useAppConfig must be used within a AppConfigProvider.');
    }
    return context.config;
};
//# sourceMappingURL=useConfig.js.map